import { useEffect } from "react";
import { useSiteConfig } from "@/context/SiteConfigContext";

// Loads Tawk.to live-chat asynchronously when Admin has configured a property + widget id.
export default function TawkWidget() {
  const { config } = useSiteConfig();
  const prop = config?.tawk_property_id?.trim();
  const widget = config?.tawk_widget_id?.trim();

  useEffect(() => {
    if (!prop || !widget) return;
    if (document.getElementById("tawk-script")) return;
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_API.customStyle = {
      visibility: {
        desktop: { position: "br", xOffset: 24, yOffset: 88 },
        mobile: { position: "br", xOffset: 12, yOffset: 84 },
      },
    };
    // Keep the default Tawk launcher hidden — chat is opened only via our unified support button.
    // Tawk re-shows its launcher on chat-end and status transitions, so re-hide on those too
    // (guarded so an actively open chat window is never pulled down mid-conversation).
    const hideLauncher = () => { try { window.Tawk_API.hideWidget(); } catch (e) { /* noop */ } };
    const hideUnlessChatting = () => {
      try {
        if (window.Tawk_API.isChatMaximized && window.Tawk_API.isChatMaximized()) return;
        window.Tawk_API.hideWidget();
      } catch (e) { /* noop */ }
    };
    window.Tawk_API.onLoad = hideLauncher;
    window.Tawk_API.onChatMinimized = hideLauncher;
    window.Tawk_API.onChatEnded = hideLauncher;
    window.Tawk_API.onStatusChange = hideUnlessChatting;
    window.Tawk_LoadStart = new Date();
    const s = document.createElement("script");
    s.id = "tawk-script";
    s.async = true;
    s.src = `https://embed.tawk.to/${prop}/${widget}`;
    s.charset = "UTF-8";
    document.body.appendChild(s);
  }, [prop, widget]);

  return null;
}
